import primaryComponents from "../../../primaryComponents";
import globalStyle from "../../../../assets/styles/base/globalPage.module.scss";
import confirmReceiptImg from "../../../../assets/images/warning.svg";
import { formatCurrency } from "../../../../helpers";

export const ConfirmReceiptGeneration = ({
  closeModal = () => {},
  action = () => {},
  customer,
  amount,
  storeDetails,
}) => {
  return (
    <div className="d-flex flex-column p-2" style={{ gap: "25px" }}>
      <div className="d-flex flex-column text-center" style={{ gap: "10px" }}>
        <img
          src={confirmReceiptImg}
          alt="confirm-receipt-generation"
          style={{ width: "100px", alignSelf: "center" }}
        />
        <h4 className="text-danger">
          Are you sure you want to proceed to charge this customer?
        </h4>
        <div className={globalStyle.cardWithBackground} style={{ gap: "5px" }}>
          <p>
            Customer:
            <strong className="dark--text">
              {customer?.customerName || "N/A"}
            </strong>
          </p>
          <p>
            Amount:{" "}
            <strong className="dark--text">
              {formatCurrency({
                value: amount,
                currencyCode: storeDetails?.currency_code,
              })}
            </strong>
          </p>
        </div>
      </div>
      <div className="d-flex mt-2" style={{ gap: "15px" }}>
        <primaryComponents.Button
          classNames={"btn btn--outline mt-3 w-50"}
          onClick={() => closeModal()}
        >
          No
        </primaryComponents.Button>
        <primaryComponents.Button
          classNames={"btn btn--primary mt-3 w-50"}
          onClick={() => {
            closeModal();
            action();
          }}
        >
          Yes
        </primaryComponents.Button>
      </div>
    </div>
  );
};
